/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SelectRouteImport } from './routes/select'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AccountLayoutRouteImport } from './routes/_accountLayout'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TimetableStationCodeRouteImport } from './routes/_timetable/$stationCode'
import { Route as AuthenticatedAgentLayoutRouteImport } from './routes/_authenticated/_agentLayout'
import { Route as AccountLayoutResetPasswordRouteImport } from './routes/_accountLayout/reset-password'
import { Route as AccountLayoutLoginRouteImport } from './routes/_accountLayout/login'
import { Route as AuthenticatedAgentLayoutUpdatePasswordRouteImport } from './routes/_authenticated/_agentLayout/update-password'
import { Route as AuthenticatedAgentLayoutStationsIndexRouteImport } from './routes/_authenticated/_agentLayout/stations/index'

const SelectRoute = SelectRouteImport.update({
  id: '/select',
  path: '/select',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountLayoutRoute = AccountLayoutRouteImport.update({
  id: '/_accountLayout',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TimetableStationCodeRoute = TimetableStationCodeRouteImport.update({
  id: '/_timetable/$stationCode',
  path: '/$stationCode',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedAgentLayoutRoute =
  AuthenticatedAgentLayoutRouteImport.update({
    id: '/_agentLayout',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AccountLayoutResetPasswordRoute =
  AccountLayoutResetPasswordRouteImport.update({
    id: '/reset-password',
    path: '/reset-password',
    getParentRoute: () => AccountLayoutRoute,
  } as any)
const AccountLayoutLoginRoute = AccountLayoutLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AccountLayoutRoute,
} as any)
const AuthenticatedAgentLayoutUpdatePasswordRoute =
  AuthenticatedAgentLayoutUpdatePasswordRouteImport.update({
    id: '/update-password',
    path: '/update-password',
    getParentRoute: () => AuthenticatedAgentLayoutRoute,
  } as any)
const AuthenticatedAgentLayoutStationsIndexRoute =
  AuthenticatedAgentLayoutStationsIndexRouteImport.update({
    id: '/stations/',
    path: '/stations/',
    getParentRoute: () => AuthenticatedAgentLayoutRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/select': typeof SelectRoute
  '/login': typeof AccountLayoutLoginRoute
  '/reset-password': typeof AccountLayoutResetPasswordRoute
  '/$stationCode': typeof TimetableStationCodeRoute
  '/update-password': typeof AuthenticatedAgentLayoutUpdatePasswordRoute
  '/stations/': typeof AuthenticatedAgentLayoutStationsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/select': typeof SelectRoute
  '/login': typeof AccountLayoutLoginRoute
  '/reset-password': typeof AccountLayoutResetPasswordRoute
  '/$stationCode': typeof TimetableStationCodeRoute
  '/update-password': typeof AuthenticatedAgentLayoutUpdatePasswordRoute
  '/stations': typeof AuthenticatedAgentLayoutStationsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_accountLayout': typeof AccountLayoutRouteWithChildren
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/select': typeof SelectRoute
  '/_accountLayout/login': typeof AccountLayoutLoginRoute
  '/_accountLayout/reset-password': typeof AccountLayoutResetPasswordRoute
  '/_authenticated/_agentLayout': typeof AuthenticatedAgentLayoutRouteWithChildren
  '/_timetable/$stationCode': typeof TimetableStationCodeRoute
  '/_authenticated/_agentLayout/update-password': typeof AuthenticatedAgentLayoutUpdatePasswordRoute
  '/_authenticated/_agentLayout/stations/': typeof AuthenticatedAgentLayoutStationsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/select'
    | '/login'
    | '/reset-password'
    | '/$stationCode'
    | '/update-password'
    | '/stations/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/select'
    | '/login'
    | '/reset-password'
    | '/$stationCode'
    | '/update-password'
    | '/stations'
  id:
    | '__root__'
    | '/'
    | '/_accountLayout'
    | '/_authenticated'
    | '/select'
    | '/_accountLayout/login'
    | '/_accountLayout/reset-password'
    | '/_authenticated/_agentLayout'
    | '/_timetable/$stationCode'
    | '/_authenticated/_agentLayout/update-password'
    | '/_authenticated/_agentLayout/stations/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccountLayoutRoute: typeof AccountLayoutRouteWithChildren
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  SelectRoute: typeof SelectRoute
  TimetableStationCodeRoute: typeof TimetableStationCodeRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/select': {
      id: '/select'
      path: '/select'
      fullPath: '/select'
      preLoaderRoute: typeof SelectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_accountLayout': {
      id: '/_accountLayout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AccountLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_timetable/$stationCode': {
      id: '/_timetable/$stationCode'
      path: '/$stationCode'
      fullPath: '/$stationCode'
      preLoaderRoute: typeof TimetableStationCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/_agentLayout': {
      id: '/_authenticated/_agentLayout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedAgentLayoutRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_accountLayout/reset-password': {
      id: '/_accountLayout/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AccountLayoutResetPasswordRouteImport
      parentRoute: typeof AccountLayoutRoute
    }
    '/_accountLayout/login': {
      id: '/_accountLayout/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AccountLayoutLoginRouteImport
      parentRoute: typeof AccountLayoutRoute
    }
    '/_authenticated/_agentLayout/update-password': {
      id: '/_authenticated/_agentLayout/update-password'
      path: '/update-password'
      fullPath: '/update-password'
      preLoaderRoute: typeof AuthenticatedAgentLayoutUpdatePasswordRouteImport
      parentRoute: typeof AuthenticatedAgentLayoutRoute
    }
    '/_authenticated/_agentLayout/stations/': {
      id: '/_authenticated/_agentLayout/stations/'
      path: '/stations'
      fullPath: '/stations/'
      preLoaderRoute: typeof AuthenticatedAgentLayoutStationsIndexRouteImport
      parentRoute: typeof AuthenticatedAgentLayoutRoute
    }
  }
}

interface AccountLayoutRouteChildren {
  AccountLayoutLoginRoute: typeof AccountLayoutLoginRoute
  AccountLayoutResetPasswordRoute: typeof AccountLayoutResetPasswordRoute
}

const AccountLayoutRouteChildren: AccountLayoutRouteChildren = {
  AccountLayoutLoginRoute: AccountLayoutLoginRoute,
  AccountLayoutResetPasswordRoute: AccountLayoutResetPasswordRoute,
}

const AccountLayoutRouteWithChildren = AccountLayoutRoute._addFileChildren(
  AccountLayoutRouteChildren,
)

interface AuthenticatedAgentLayoutRouteChildren {
  AuthenticatedAgentLayoutUpdatePasswordRoute: typeof AuthenticatedAgentLayoutUpdatePasswordRoute
  AuthenticatedAgentLayoutStationsIndexRoute: typeof AuthenticatedAgentLayoutStationsIndexRoute
}

const AuthenticatedAgentLayoutRouteChildren: AuthenticatedAgentLayoutRouteChildren =
  {
    AuthenticatedAgentLayoutUpdatePasswordRoute:
      AuthenticatedAgentLayoutUpdatePasswordRoute,
    AuthenticatedAgentLayoutStationsIndexRoute:
      AuthenticatedAgentLayoutStationsIndexRoute,
  }

const AuthenticatedAgentLayoutRouteWithChildren =
  AuthenticatedAgentLayoutRoute._addFileChildren(
    AuthenticatedAgentLayoutRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedAgentLayoutRoute: typeof AuthenticatedAgentLayoutRouteWithChildren
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAgentLayoutRoute: AuthenticatedAgentLayoutRouteWithChildren,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountLayoutRoute: AccountLayoutRouteWithChildren,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  SelectRoute: SelectRoute,
  TimetableStationCodeRoute: TimetableStationCodeRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
